import React, { Component } from 'react'
import NavBarV from './NavBarV'
import AuthA from '../../store/actions/AuthA'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'redux'

import axios from 'axios'

class NavBarC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notifications: [],
    };
  }

  logout = () => { this.props.authFn.logout()}

  notificationClick = (id) => {
    const url = process.env.REACT_APP_URL+'/notifications/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: {isRead: true}
      })
      .then(response => {
        this.getNotifications(response.data.teacherId);
        this.props.history.push(response.data.link);
      })
      .catch(err => console.log(err));
  }

  getNotifications = (userId) => {
    const url = process.env.REACT_APP_URL+'/notifications?filter[where][teacherId]='+userId;
    axios
      .request({
        method: 'get',
        url: url
      })
      .then(response => this.setState({notifications: response.data}))
      .catch(err => console.log(err));
  }

  componentDidMount() {
    this.getNotifications(this.props.userId);
  }

  componentWillReceiveProps(newProps) {
    this.getNotifications(newProps.userId);
  }

  render() {
    return (
      <NavBarV
        auth={this.props.auth}
        username={this.props.username}
        userType={this.props.userType}
        notifications={this.state.notifications}
        notificationClick={this.notificationClick}
        logout={this.logout}
        title={this.props.title}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    username: state.AuthR.username,
    userType: state.AuthR.userType,
    userId: state.AuthR.userId
  }
}

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(NavBarC);
